import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';
import { ThreadObject } from '@/types';

export function useGetThreads(matterId: string, subsetId: string) {
  const fetcher = useFetcher();

  return useQuery<ThreadObject[]>(
    [QueryEntity.Threads, { matterId, subsetId }],
    () => {
      if (!matterId || !subsetId) {
        return [] as ThreadObject[];
      }

      return fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/threads`);
    },
    {
      refetchOnWindowFocus: false,
    },
  );
}
